import { TileRoleRoute } from '@/types'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { ManagementGridExtendedColumn } from '@/routes/admin/components/ManagementGrid/types'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'
import { faLaptopCode } from '@fortawesome/free-solid-svg-icons'

const qsApplicationAdditionalColumns: ManagementGridExtendedColumn[] = [
  {
    dataField: 'corporate',
    caption: 'Corporate',
    dataType: 'boolean',
    allowEditing: true,
    width: 100,
  },
]

export const QSApplicationRoute: TileRoleRoute = {
  path: 'qsapplications',
  text: 'Applicazioni QS',
  faIcon: faLaptopCode,
  element: (
    <ManagementGridFactory
      entity="qs_applicazione"
      referencesCollection={'applicazioni_licenze'}
      referencesTitle="Applicazioni QS"
      displayField="id"
      additionalColumns={qsApplicationAdditionalColumns}
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Applicazioni QS',
      icon: faLaptopCode,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
